/* Brilinton header / drawer helper
 * v58: moved out of footer-group custom-liquid into an owned asset.
 * Keeps the approved custom hamburger/cart/menu state behavior with guards.
 */
(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function setBodyUnlocked() {
    document.body.classList.remove('overflow-hidden');
  }

  function createHamburgerButton() {
    var headerDrawer = document.querySelector('header-drawer[data-breakpoint="tablet"]');
    if (!headerDrawer) return;

    var existing = document.getElementById('hamburger-button') || headerDrawer.querySelector('.hamburger');
    if (existing) return;

    var hamburger = document.createElement('div');
    hamburger.id = 'hamburger-button';
    hamburger.className = 'hamburger';
    hamburger.setAttribute('role', 'button');
    hamburger.setAttribute('aria-label', 'Menu');
    hamburger.setAttribute('tabindex', '0');

    ['line1', 'line2', 'line3'].forEach(function (lineClass) {
      var line = document.createElement('span');
      line.classList.add('line', lineClass);
      hamburger.appendChild(line);
    });

    headerDrawer.appendChild(hamburger);

    var summary = document.querySelector('summary.header__icon');
    var cartDrawer = document.querySelector('cart-drawer');

    function activateClick() {
      if (!summary && !cartDrawer) return;
      hamburger.classList.toggle('active');

      if (cartDrawer && cartDrawer.classList.contains('active')) {
        cartDrawer.classList.remove('active');
        hamburger.classList.remove('active');
        setBodyUnlocked();
      } else if (summary) {
        summary.click();
      }
    }

    hamburger.addEventListener('click', activateClick);
    hamburger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateClick();
      }
    });

    if (cartDrawer) {
      var observer = new MutationObserver(function () {
        if (cartDrawer.classList.contains('active')) {
          hamburger.classList.add('active');
        } else {
          hamburger.classList.remove('active');
          setBodyUnlocked();
        }
      });

      observer.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function bindCartIcon() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || cartIcon.dataset.b1HeaderHelperBound === 'true') return;
    cartIcon.dataset.b1HeaderHelperBound = 'true';

    cartIcon.addEventListener('click', function () {
      var hamburger = document.querySelector('#hamburger-button, header-drawer .hamburger');
      var cartDrawer = document.querySelector('cart-drawer');
      var closeButton = document.querySelector('.drawer__close');
      var menuContainer = document.querySelector('#Details-menu-drawer-container');

      if (menuContainer && menuContainer.hasAttribute('open')) {
        var menuSummary = menuContainer.querySelector('summary');
        if (menuSummary) menuSummary.click();
      }

      if (cartDrawer && cartDrawer.classList.contains('active')) {
        window.setTimeout(function () {
          if (hamburger) hamburger.classList.remove('active');
          setBodyUnlocked();
          if (closeButton) closeButton.click();
        }, 10);
      }
    });
  }

  function bindSubmenuAutoClose() {
    document.querySelectorAll('.menu-drawer__inner-submenu').forEach(function (submenu) {
      if (submenu.dataset.b1SubmenuBound === 'true') return;
      submenu.dataset.b1SubmenuBound = 'true';

      submenu.addEventListener('click', function (event) {
        var clickedDetails = event.target.closest && event.target.closest('details');
        if (!clickedDetails) return;

        submenu.querySelectorAll('details').forEach(function (details) {
          if (details !== clickedDetails) details.removeAttribute('open');
        });
      });
    });
  }

  function openDesktopHeaderMenus() {
    window.setTimeout(function () {
      document.querySelectorAll('header-menu > details').forEach(function (detail) {
        detail.setAttribute('open', '');
      });
    }, 500);
  }

  ready(function () {
    createHamburgerButton();
    bindCartIcon();
    bindSubmenuAutoClose();
    openDesktopHeaderMenus();
  });
})();
